import { apiSlice } from '@/store/api/apiSlice';
import { getMonthlyDateRange } from '@/utils/getMonthlyDateRange';
import { getTransitTimestamp } from '@/utils/getTransitTimestamp';

import type { WeeklyTransitWithAspectResponse } from './weeklyTransitWithAspect.api';

export const monthlyTransitWithAspectApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMonthlyTransitWithAspect: builder.query<
      WeeklyTransitWithAspectResponse[],
      { monthType?: 'current' | 'next' }
    >({
      query: ({ monthType = 'current' }: { monthType?: 'current' | 'next' } = {}) => {
        const { fromDate, toDate } = getMonthlyDateRange(monthType);

        return {
          url: '/transits/week-transit-with-aspect',
          method: 'GET',
          params: {
            fromDate,
            toDate,
          },
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetMonthlyTransitWithAspectQuery } = monthlyTransitWithAspectApi;
